import { Controller } from "@hotwired/stimulus"

const DISABLED_CLASSES = ['opacity-60', 'cursor-not-allowed', 'brightness-75']

// Disables the button and shows a spinner while a PDF is being generated
export default class extends Controller {
  static targets = ["button", "spinner"]
  static values = {
    url: String,
    errorMessage: String
  }

  async download(event) {
    event.preventDefault()

    if (this.buttonTarget.disabled) return

    this.buttonTarget.disabled = true
    this.buttonTarget.classList.add(...DISABLED_CLASSES)
    this.spinnerTarget.classList.remove('hidden')

    try {
      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "Accept": "application/pdf",
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content || ''
        }
      })

      if (!response.ok) throw new Error(`Unexpected response status: ${response.status}`)

      const blob = await response.blob()
      const downloadUrl = URL.createObjectURL(blob)

      const link = document.createElement('a')
      link.href = downloadUrl
      link.download = this._filenameFrom(response) || 'download.pdf'
      document.body.appendChild(link)
      link.click()
      link.remove()

      URL.revokeObjectURL(downloadUrl)
    } catch (error) {
      alert(this.errorMessageValue)
    } finally {
      this.buttonTarget.disabled = false
      this.buttonTarget.classList.remove(...DISABLED_CLASSES)
      this.spinnerTarget.classList.add('hidden')
    }
  }

  _filenameFrom(response) {
    const disposition = response.headers.get('Content-Disposition') || ''
    const match = disposition.match(/filename="?([^"]+)"?/)

    return match?.[1]
  }
}
